<template>
  <div>
    <div class="d-flex align-items-center">
      <div class="side-frame-success"></div>
      <div style="font-size: 14px; color: #606266">
        <span>
          {{ $l('INDEX.table_label_product_information') || '产品信息' }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: { disabled: { type: Boolean, default: false } },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
}
</style>